<template>
  <div>
    <section class="top">
      <div class="header">
        <div class="header-svg clouds"></div>
        <div class="container">
          <div class="columns">
            <div class="column is-6">
              <h1 class="title is-1 mb-6 has-text-left" ref="logo">Blog</h1>
              <p class="subtitle is-5" ref="logotext">Lees over de laatste ontwikkelingen van Ikleeralles.nl. Of ben je benieuwd hoe je het beste woordjes kan leren?</p>
            </div>
            <div class="column is-6 has-text-centered">
              <img class="image-300" src="../../assets/undraw/blog.svg">
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="columns is-multiline is-marginless">
        <div class="column is-6" v-for="post in posts" :key="post.id">
          <div class="card">
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-4">{{ post.title }}</p>
                </div>
              </div>
              <div class="content mt-5 has-text-right">
                <b-button type="is-info" tag="router-link" :to="'/blog/' + post.id">Bekijk</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApiService from "@/common/api.service"
import router from "@/router"
import showdown from "showdown"

const converter = new showdown.Converter()

export default {
  data() {
    return {
      posts: []
    }
  },
  mounted() {
    this.getPosts()
  },
  methods: {
    async getPosts() {
      let response = await ApiService.get("https://blog.ikleeralles.nl/blogposts", true, false)
      this.posts = response.data.reverse()
    },
    shorten(text) {
      return text.substring(0, 100)
    },
    convertHtml(text) {
      return converter.makeHtml(text)
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 20px;
}

.card {
  margin-bottom: 20px;
  box-shadow: none;
}

.hero {
  margin-bottom: 100px;
}

.header {
  background: #1d73f4;
  padding: 50px 0;
  .logo {
    max-width: 40%;
  }
  .title,
  .subtitle {
    color: #fff;
  }
  .header-svg {
    position: absolute;
    &.clouds {
      top: 0;
      width: 100%;
      height: 100%;
      background: url("~@/assets/header-clouds.svg");
    }
  }
}

.image-300 {
  max-height: 300px;
}
</style>
